import { Badge } from '@shopify/polaris';
import { ENUM_TRIP_MANIFEST_STATUS } from 'queries/trip_manifest.query';

export const getTripStatusBadge = (status: ENUM_TRIP_MANIFEST_STATUS): JSX.Element | undefined => {
  switch (status) {
    case ENUM_TRIP_MANIFEST_STATUS.DRAFT:
      return <Badge>Bản nháp</Badge>;
    case ENUM_TRIP_MANIFEST_STATUS.DISPATCHED:
      return <Badge tone="info">Đã điều chuyến</Badge>;
    case ENUM_TRIP_MANIFEST_STATUS.IN_TRANSIT:
      return <Badge tone="critical">Đang chạy</Badge>;
    case ENUM_TRIP_MANIFEST_STATUS.COMPLETED:
      return <Badge tone="success">Hoàn thành</Badge>;
    case ENUM_TRIP_MANIFEST_STATUS.FINALIZED:
      return <Badge tone="success-strong">Đã chốt lệnh</Badge>;
    case ENUM_TRIP_MANIFEST_STATUS.CANCELLED:
      return <Badge>Đã hủy</Badge>;
    default:
      // Xử lý trường hợp không xác định nếu cần
      return undefined;
  }
};

export const getTripStatusBadge2 = (status: ENUM_TRIP_MANIFEST_STATUS): JSX.Element | undefined => {
  switch (status) {
    case ENUM_TRIP_MANIFEST_STATUS.DRAFT:
      return <Badge size="small">Bản nháp</Badge>;
    case ENUM_TRIP_MANIFEST_STATUS.DISPATCHED:
      return null;
    //   return <Badge tone="info">Đã điều chuyến</Badge>;
    case ENUM_TRIP_MANIFEST_STATUS.IN_TRANSIT:
      return (
        <Badge tone="critical" size="small">
          Đang chạy
        </Badge>
      );
    case ENUM_TRIP_MANIFEST_STATUS.COMPLETED:
      return (
        <Badge tone="success" size="small">
          Hoàn thành
        </Badge>
      );
    case ENUM_TRIP_MANIFEST_STATUS.FINALIZED:
      return (
        <Badge tone="success-strong" size="small">
          Đã chốt lệnh
        </Badge>
      );
    case ENUM_TRIP_MANIFEST_STATUS.CANCELLED:
      return <Badge size="small">Đã hủy</Badge>;
    default:
      // Xử lý trường hợp không xác định nếu cần
      return undefined;
  }
};

